export const initialState = {
    cloud: {},
    coord: {},
    main: {},
    sys: {},
    weather: [],
    wind: {},
};
